import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { PRIMITIVE_COLORS } from '@/constants/residents/residentColors';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

export type EventTabType = 'upcoming' | 'past';

interface EventsGlassTabFilterProps {
  selectedTab: EventTabType;
  onTabChange: (tab: EventTabType) => void;
}

interface TabButtonProps {
  label: string;
  isActive: boolean;
  onPress: () => void;
}

const TabButton: React.FC<TabButtonProps> = React.memo(({ label, isActive, onPress }) => {
  const { colors } = useThemeColors();
  return (
    <TouchableOpacity
      style={[styles.tab, isActive && styles.tabActive]}
      onPress={onPress}
      activeOpacity={0.7}
      accessibilityRole="button"
      accessibilityState={{ selected: isActive }}
    >
      <Text style={[styles.tabLabel, { color: colors.text.dim }, isActive && { color: PRIMITIVE_COLORS.resioBlue }]}>
        {label}
      </Text>
    </TouchableOpacity>
  );
});

TabButton.displayName = 'TabButton';

export const EventsGlassTabFilter: React.FC<EventsGlassTabFilterProps> = React.memo(({
  selectedTab,
  onTabChange,
}) => {
  const { colors } = useThemeColors();
  return (
  <View style={[styles.container, { backgroundColor: colors.card.bg, borderColor: colors.card.border }]}>
    <TabButton
      label="Upcoming"
      isActive={selectedTab === 'upcoming'}
      onPress={() => onTabChange('upcoming')}
    />
    <TabButton
      label="Past"
      isActive={selectedTab === 'past'}
      onPress={() => onTabChange('past')}
    />
  </View>
  );
});

EventsGlassTabFilter.displayName = 'EventsGlassTabFilter';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderWidth: 1,
    borderRadius: 14,
    padding: 5,
    marginTop: 16,
  },
  tab: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: 38,
    borderRadius: 11,
  },
  tabActive: {
    backgroundColor: 'rgba(70,114,254,0.12)',
  },
  tabLabel: {
    ...REDESIGN_TYPOGRAPHY.button,
  },
});
